// extracted by mini-css-extract-plugin
export default {"skeletonPill":"GroupButtonsSkeleton_skeletonPill__nCwTI","shimmer":"GroupButtonsSkeleton_shimmer__JuUtY"};